import {ISVPlayer, svPlayerType} from "./interfaces";
import ReactDOM from "react-dom";
import React from "react";
import {Provider} from "react-redux";
import store from "../../products/product-page/data-services/store";
import SVPlayer from "./sv-player";


/**
 * entry point
 */
export const init = () => {
    const $svPlayerApp = document.querySelectorAll('[sv-player]') ;
    let cnt = 1;
    $svPlayerApp.forEach($svPlayer  => {
        const $svPlayerTypeStr = $svPlayer.getAttribute('sv-player');

        if(!$svPlayer || !$svPlayer.textContent || !$svPlayerTypeStr)
            return;

        const $svPlayerData =  document.querySelectorAll('[sv-player-data="'+$svPlayerTypeStr+'"]');
        if(!$svPlayerData || !$svPlayerData[0] || !$svPlayerData[0].textContent)
            return;

        let svPlayerSources;
        try{
            svPlayerSources= JSON.parse($svPlayerData[0].textContent) as ISVPlayer[];

        }
        catch(ex){}
        if(!svPlayerSources)
            return;
        //svPlayerSources = svPlayerSources.filter(f=>f.group.startsWith('Audio'));
        /*Remove hidden from player*/
        $svPlayer.classList.remove('hidden');

        const elId = cnt++;
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                    <SVPlayer svPlayerSources={svPlayerSources} svPlayerType={svPlayerType[$svPlayerTypeStr as keyof typeof svPlayerType]}   elId={elId}/>
                </Provider>
            </React.StrictMode>,
            $svPlayer
        );
    });
};

/**
 * entry point
 */
document.addEventListener('DOMContentLoaded', () => {
    init();
});